export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-8 h-8 ${className ?? ""}`}
      aria-hidden="true"
    >
      {/* House shape */}
      <path
        d="M16 4L3 14h3v13h8v-8h4v8h8V14h3L16 4z"
        fill="currentColor"
        opacity="0.9"
      />
      {/* Wrench crossbar */}
      <path
        d="M12 17l8-8"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <circle cx="11" cy="18" r="2" fill="white" />
      <circle cx="21" cy="8" r="2" fill="white" />
    </svg>
  );
}
